export const SET_LOADING='SET_LOADING'
export const GET_ALL_DATA='GET_ALL_DATA'
export const GET_ALL_DATA_SUCCESS='GET_ALL_DATA_SUCCESS'
export const GET_SINGLE_COIN_DATA='GET_SINGLE_COIN_DATA'
export const GET_SINGLE_COIN_DATA_SUCCESS='GET_SINGLE_COIN_DATA_SUCCESS'
export const GET_SINGLE_COIN_CHART='GET_SINGLE_COIN_CHART'
export const GET_SINGLE_COIN_CHART_SUCCESS='GET_SINGLE_COIN_CHART_SUCCESS'
export const GET_ALL_COIN_DATA_FOR_AUTOSUGGEST='GET_ALL_COIN_DATA_FOR_AUTOSUGGEST'
export const GET_ALL_COIN_DATA_FOR_AUTOSUGGEST_SUCCESS='GET_ALL_COIN_DATA_FOR_AUTOSUGGEST_SUCCESS'
